import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

export function getMenuListsConfigs() {
    return {
        palette: {
            [PALETTE_IDS.MINI_EVENT_ITEM]: {
                MINI_EVENT_ITEM_SELECTED_CONTENT: {
                    MINI_EVENT_ITEM_TIMING_STATUS: {
                        EVENT_TIMING_LIVE_TEXT: COLOR.BRAND.FOREGROUND6,
                        EVENT_TIMING_UPCOMING_TEXT: COLOR.BRAND.FOREGROUND6,
                        STREAMING_INDICATOR: {
                            INDICATOR_ICON_COLOR: COLOR.BRAND.FOREGROUND6,
                        },
                    },
                    MINI_EVENT_ITEM_SCOREBOARD: {
                        MINI_SCOREBOARD_SCORES_TEXT: {
                            fontWeight: FONT.WEIGHT_SEMI_BOLD,
                            color: COLOR.BRAND.FOREGROUND6,
                        },
                        MINI_SCOREBOARD_SCORE_COUNT_TEXT: {
                            fontWeight: FONT.WEIGHT_BOLD,
                            color: COLOR.BRAND.BACKGROUND3,
                        },
                        MINI_SCOREBOARD_SEGMENT_INDICATOR_TEXT: COLOR.BRAND.FOREGROUND6,
                        MINI_SCOREBOARD_SERVER_INDICATOR: COLOR.BRAND.BACKGROUND3,
                    },
                    MINI_EVENT_ITEM_PARTICIPANTS: {
                        PARTICIPANTS_TEXT: {
                            color: COLOR.BRAND.FOREGROUND6,
                            fontWeight: FONT.WEIGHT_NORMAL,
                        },
                    },
                    MINI_EVENT_ITEM_CHEVRON_ICON_COLOR: COLOR.BRAND.FOREGROUND6,
                },
            },
            [PALETTE_IDS.MENUS_LINKS_LISTS]: {
                LHM_HEADER_TEXT: COLOR.BRAND.FOREGROUND1,
            },
            [PALETTE_IDS.LIST_ITEM]: {
                LIST_ITEM_SELECTED_ICON_COLOR: COLOR.BRAND.FOREGROUND6,
                LIST_ITEM_SELECTED_TEXT: COLOR.BRAND.FOREGROUND6,
            },
            [PALETTE_IDS.AZ_MENU]: {
                DESKTOP_AZ_EXPAND_BUTTON: {
                    TERTIARY_BUTTON_TEXT: {
                        color: COLOR.BRAND.FOREGROUND1,
                        fontSize: FONT.SIZE_SMALL,
                    },
                },
                DESKTOP_AZ_FAVORITE_ICON_COLOR: COLOR.BRAND.FOREGROUND1,
                MOBILE_AZ_CONTAINER_BG: COLOR.BRAND.BACKGROUND1,
                MOBILE_AZ_FAVORITE_ICON_COLOR: COLOR.BRAND.FOREGROUND1,
                MOBILE_AZ_ALL_SPORTS_BUTTON: {
                    TERTIARY_BUTTON_TEXT: COLOR.BRAND.ACCENT1,
                },
                MOBILE_AZ_CLOSE_BUTTON: {
                    CIRCULAR_CLOSE_BUTTON_BG: COLOR.BRAND.BACKGROUND4,
                    CIRCULAR_CLOSE_BUTTON_ICON_COLOR: COLOR.BRAND.FOREGROUND5,
                },
                MOBILE_AZ_BACK_BUTTON_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontWeight: FONT.WEIGHT_BOLD,
                },
            },
            [PALETTE_IDS.QUICK_NAVIGATIONS]: {
                QUICK_NAVIGATIONS_TITLE_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontSize: FONT.SIZE_MEDIUM,
                    fontWeight: FONT.WEIGHT_BOLD,
                    textTransform: 'capitalize',
                },
            },
        },
    };
}
